import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './account/login/login.component';
import { RegisterComponent } from './account/register/register.component';
import { UsersComponent } from './account/users/users.component';
import { authGuard } from './auth.guard';
import { ManualEntryComponent } from './strike-walks/manual-entry/manual-entry.component';
import { AllStrikesComponent } from './strikes/all-strikes/all-strikes.component';
import { HomeComponent } from './strikes/home/home.component';
import { NewStrikeComponent } from './strikes/new-strike/new-strike.component';
import { PicketSignInComponent } from './strikes/picket-sign-in/picket-sign-in.component';
import { PicketSignOutComponent } from './strikes/picket-sign-out/picket-sign-out.component';
import { StrikeDetailsComponent } from './strikes/strike-details/strike-details.component';
import { StrikeEditComponent } from './strikes/strike-edit/strike-edit.component';
import { StrikeMembersComponent } from './strikes/strike-members/strike-members.component';
import { StrikeRegisterComponent } from './strikes/strike-register/strike-register.component';
import { WalkHistoryComponent } from './strikes/walk-history/walk-history.component';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [authGuard]},
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [authGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [authGuard] },
  { path: 'strikes', component: AllStrikesComponent, canActivate: [authGuard] },
  { path: 'strikes/add', component: NewStrikeComponent, canActivate: [authGuard]},
  { path: 'strikes/:id', component: StrikeDetailsComponent, canActivate: [authGuard] },
  { path: 'strikewalk/strike/:id', component: WalkHistoryComponent, canActivate: [authGuard]},
  { path: 'strikes/edit/:id', component: StrikeEditComponent, canActivate: [authGuard]},
  { path: 'strikemembers/strikehouse/:id', component: StrikeMembersComponent, canActivate: [authGuard]},
  { path: 'strikemembers/registration/house/:id', component: StrikeRegisterComponent, canActivate: [authGuard]},
  { path: 'signin/strike/:id/picketline/:picket/:name', component: PicketSignInComponent, canActivate: [authGuard]},
  { path: 'signout/strike/:id/picketline/:picket/:name', component: PicketSignOutComponent, canActivate: [authGuard]},
  { path: 'manualentry/strike/:id/picketline/:picket/:name', component: ManualEntryComponent, canActivate: [authGuard]},
  { path: 'users', component: UsersComponent, canActivate: [authGuard]}
];


@NgModule({
  declarations: [],
  imports: [
    CommonModule, RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
